/* Afroyla Biggest Sale 2026 signup LP — countdown + pre/live/ended state machine.
 * Settings (ISO with offset): data-abs-sale-start / data-abs-sale-end on [data-abs].
 * Self-check: Nov 6, 2026 10:00 AM is EST (UTC-5, DST ends Nov 1 2026) → 10:00 ET = 15:00 UTC. If the default
 * setting ever drifts to a DST-active offset by mistake, this assertion fails loudly in the console instead of
 * silently showing a countdown off by one hour.
 */
(function () {
  var root = document.querySelector('[data-abs]');
  if (!root) return;

  var DEFAULT_START = '2026-11-06T10:00:00-05:00';
  var selfCheck = new Date(DEFAULT_START).toISOString();
  console.assert(selfCheck === '2026-11-06T15:00:00.000Z', 'ABS countdown self-check failed: ' + selfCheck + ' (expected 2026-11-06T15:00:00.000Z — Nov 6 10am ET must be EST/UTC-5)');

  var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var start = Date.parse(root.dataset.absSaleStart || DEFAULT_START);
  var end = Date.parse(root.dataset.absSaleEnd);
  var state = null; // 'pre' | 'live' | 'ended'

  var topbar = root.querySelector('[data-abs-topbar]');
  var heroHeadline = root.querySelector('[data-abs-hero-headline]');
  var formCard = root.querySelector('[data-abs-form-card]');
  var tplTopbarLive = root.querySelector('template[data-abs-topbar-live]');
  var tplTopbarEnded = root.querySelector('template[data-abs-topbar-ended]');
  var tplHeroLive = root.querySelector('template[data-abs-hero-live]');
  var tplHeroEnded = root.querySelector('template[data-abs-hero-ended]');
  var tplFormEnded = root.querySelector('template[data-abs-form-ended]');

  function pad(n) { return (n < 10 ? '0' : '') + n; }
  function fmt(ms) {
    var s = Math.max(0, Math.floor(ms / 1000));
    var d = Math.floor(s / 86400), h = Math.floor((s % 86400) / 3600), m = Math.floor((s % 3600) / 60);
    return d + 'd : ' + pad(h) + 'h : ' + pad(m) + 'm';
  }

  function computeState() {
    var now = Date.now();
    if (!isNaN(start) && now < start) return 'pre';
    if (!isNaN(end) && now < end) return 'live';
    return 'ended';
  }

  function applyState(next) {
    if (next === state) return;
    state = next;
    root.classList.remove('is-pre', 'is-live', 'is-ended');
    root.classList.add('is-' + next);

    if (next === 'pre' && topbar) {
      topbar.innerHTML = 'STARTS IN <span data-abs-countdown>…</span> · ' + (root.dataset.absDatesLabel || '');
    }
    if (next === 'live') {
      if (topbar && tplTopbarLive) topbar.innerHTML = tplTopbarLive.innerHTML;
      if (heroHeadline && tplHeroLive) heroHeadline.innerHTML = tplHeroLive.innerHTML;
    }
    if (next === 'ended') {
      if (topbar && tplTopbarEnded) topbar.innerHTML = tplTopbarEnded.innerHTML; // <template>.textContent is empty (content lives in .content); innerHTML is spec-cased to work
      if (heroHeadline && tplHeroEnded) heroHeadline.innerHTML = tplHeroEnded.innerHTML;
      if (formCard && tplFormEnded) formCard.innerHTML = tplFormEnded.innerHTML;
    }
  }

  function tick() {
    var next = computeState();
    applyState(next);
    root.removeAttribute('data-abs-pending');

    var target = next === 'pre' ? start : end;
    if (!isNaN(target)) {
      var text = fmt(target - Date.now());
      root.querySelectorAll('[data-abs-countdown]').forEach(function (el) { el.textContent = text; });
    }
  }

  tick();
  setInterval(tick, reducedMotion ? 30000 : 1000);
})();
